import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BillingPerYearPage = lazy(() => import('./BillingPerYearPage'));

const path = 'reports/billing/year-on-year';
const BillingPerYearRoute: FuseRouteItemType = {
	path: path,
	element: <BillingPerYearPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'YoY',
					showCrumbs: false,
					helpName: 'Billing Year on Year'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default BillingPerYearRoute;
